export function isImage(fileName) {
  return /(\.jpg|\.jpeg|\.png|\.gif)$/i.test(fileName);
}

export function isPdf(fileName) {
  return /(\.pdf)$/i.test(fileName);
}

export function isValidSize(bytes, mb) {
  return bytes < mb * 1024 * 1024;
}

export function isValidEmail(email) {
  // eslint-disable-next-line
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
}

export function isExcel(fileName) {
  return /(\.xls|\.xlsx|\.xlsm)$/i.test(fileName);
}

export function makeUrlClickable(text = '') {
  // eslint-disable-next-line
    const reg = /(?:(?:https?):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/igm;
  return text ? text.replaceAll(reg, (match) => {
    const separator = (match.startsWith('http') || match.startsWith('https')) ? '' : '//';
    return `<a href="${separator}${match}" target="_blank">${match}</a>`;
  }) : '';
}
